import { supabase } from "@/lib/supabase/client";
import { requireUserId } from "@/features/identity/api/session";

export const PROFILE_COLUMNS =
  "id,user_id,full_name,professional_title,company_name,email,phone,website,bio,profile_photo_url,company_logo_url,onboarding_completed,created_at,updated_at";

const PROTECTED = ["id", "user_id", "created_at", "updated_at"];

export async function getMyProfile() {
  const uid = await requireUserId();
  const { data, error } = await supabase.from("profiles").select(PROFILE_COLUMNS).eq("user_id", uid).maybeSingle();
  if (error) throw error;
  return data;
}

export async function getMyProfileId() {
  const uid = await requireUserId();
  const { data, error } = await supabase.from("profiles").select("id").eq("user_id", uid).single();
  if (error) throw error;
  return data.id;
}

export async function updateMyProfile(patch) {
  const uid = await requireUserId();
  const safe = Object.fromEntries(Object.entries(patch).filter(([k]) => !PROTECTED.includes(k)));
  const { data, error } = await supabase
    .from("profiles")
    .update(safe)
    .eq("user_id", uid)
    .select(PROFILE_COLUMNS)
    .single();
  if (error) throw error;
  return data;
}
